import { useContext } from 'react';
import { SessionContext } from '@/providers/SessionProvider';
import { isPlayfulTheme } from '@/lib/layout-version';

const ADMIN_PROFILES = ['Administrador', '4 secretariado', 'Professor', 'Tutor', 'Designer Institucional'];

// O tema lúdico é por TENANT (REACT_APP_NAME=infantil, build-time). Professor e
// admin logados no tenant infantil devem continuar vendo a UI corporativa —
// use este hook (e não isPlayfulTheme() puro) para gatear qualquer ramo lúdico
// em tela alcançável por não-alunos. Mesma convenção do PageLayouts/PlayfulNav:
// sem sessão (telas públicas ou fora do provider) vale o tema do tenant; com
// sessão, só aluno. Lê o SessionContext direto (sem throw) para não exigir
// provider em testes de unidade — ausência de provider ≡ sem sessão.
export default function usePlayfulStudent() {
  const context = useContext(SessionContext);
  const user = context?.session?.user;

  if (!isPlayfulTheme()) return false;
  if (!user) return true;

  // Mesma resolução last-match-wins do useAuthorityLevel.
  const profiles = user.profileNames || user['profile-names'] || [];
  let level = '';
  profiles.forEach(profile => {
    if (ADMIN_PROFILES.includes(profile)) {
      level = 'admin';
    } else if (profile === 'Aluno') {
      level = 'student';
    }
  });

  return level === 'student';
}
